import React, { useEffect, useState } from 'react';
import './modal.css';

const SwipeGallery = (props) => {

  const getHeight = (screenWidth, screenHeight) => {
    // console.log(screenWidth);
    // console.log(screenHeight);
    let imageHeight = 0;
    (screenWidth > 600) 
      ? imageHeight = screenHeight - 300
      : imageHeight = screenHeight - 350;
    return imageHeight;
  };

  const imageItems = props.imageItems;
  const screenWidth = props.screenWidth;
  const screenHeight = getHeight(screenWidth, props.screenHeight);
  // console.log(screenHeight);
  const lastImageIndex = props.lastImageIndex + 1;

  const [longTouch, setLongTouch] = useState(false);

  const [touchState, setTouchState] = useState({
    startX: 0,
    followX : 0,
    imageIndex: props.imageIndex,
    bandWidth: {width: 100 * lastImageIndex + '%'},
    bandPosition: {
      transform: 'translate3d(-' + props.imageIndex * screenWidth + 'px, 0, 0)'},
    bandClass: '',
    imageClass: ''
  });

  useEffect(() => props.onImageChange(touchState.imageIndex),
    [touchState.imageIndex]);

  const touchStart = (e) => {
    setLongTouch(false);
    setTimeout(() => setLongTouch(true), 300);

    // Capture pageX, because the object e references is mutable.
    const moveX = e.touches[0].pageX;

    setTouchState((prev) => ({
      ...prev,
      startX: moveX,
      bandClass: '',
      imageClass: '',
    }));
  };

  const touchMove = (e) => {
    const moveX = e.touches[0].pageX;

    setTouchState((prev) => {
      const followX = prev.imageIndex * screenWidth + (prev.startX - moveX);
      const maxX = screenWidth * (lastImageIndex - 1);
      const bandPosition = followX < maxX
        ? {transform: 'translate3d(-' + followX + 'px, 0, 0)'}
        : prev.bandPosition;
      return {
        ...prev,
        followX : followX,
        bandPosition : bandPosition,
      }
    });
  };

  const touchEnd = () => {
    setTouchState((prev) => {
      const imageX = prev.imageIndex * screenWidth;
      const absMoveX = Math.abs(imageX - prev.followX);

      const imageIndex = 
        (absMoveX > screenWidth / 2 || longTouch === false) 
            ? (prev.followX > imageX && prev.imageIndex < lastImageIndex - 1)
              ? prev.imageIndex + 1
              : (prev.followX < imageX && prev.imageIndex > 0)
                ? prev.imageIndex - 1 
                : prev.imageIndex
            : prev.imageIndex;

      return {
        ...prev,
        imageIndex: imageIndex,
        bandClass: 'animate',
        bandPosition: {
          transform: 'translate3d(-' + imageIndex * screenWidth + 'px, 0, 0)'}
      }
    });
  };

  const clamp = (num, min, max) =>  num <= min ? min : num >= max ? max : num;

  const advance = (step) => {
    setTouchState((prev) => {
      const nextImageIndex = clamp(
        prev.imageIndex + step, 0, lastImageIndex - 1);

      return {
        ...prev,
        imageIndex: nextImageIndex,
        bandClass: 'animate',
        bandPosition: {
          transform: 'translate3d(-' + nextImageIndex * screenWidth + 'px, 0, 0)'},
    }});
  };

  return (
    <>
    <div className="image_controler">
      <button 
        className= "modal_left"
        onClick = {() => advance(-1)}
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      <h3>{touchState.imageIndex + 1} / {lastImageIndex}</h3>
      <button 
        className= "modal_right"
        onClick = {() => advance(1)}
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    </div>

    <div 
      className="image_box"
      style = {{height: screenHeight}}
    >
      <div 
        className="swipe_container"
      >
        <div className = "swipe_inner_container">
          <ul 
            className={"image_band " + touchState.bandClass}
            style={{...touchState.bandPosition, ...touchState.bandWidth}}
            onTouchStart = {touchStart}
            onTouchMove = {touchMove}
            onTouchEnd = {touchEnd}
          >
            {imageItems.slice(0, lastImageIndex).map((e, i) => 
              <li 
                key={i}
                className="slide-wrapper"
                style = {{width: screenWidth}}
              >
                <img 
                src={e.image}
                className={"image_container " + touchState.imageClass}
                alt="images in modal"
                />
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
    </>
  )
};

export default SwipeGallery;
